import React, { PureComponent } from 'react';
import { FaExclamationTriangle } from 'react-icons/fa';
import { Translate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { firebaseConnect, getVal } from 'react-redux-firebase';
import { compose } from 'redux';
import styled from 'styled-components';

import Heading, { SubHeading } from '../../components/heading';
import Indicator from '../../components/indicator';
import SupportedDevices from '../supported-devices';

const Container = styled.div`
  padding: 0 1em 5em;
  background: #f0f0f0;
  color: #111111;
`;

const Content = styled.div`
  background: #171717;
  border-radius: 0.3em;
  color: white;
  margin: 2em auto 0;
  max-width: 35em;
`;

const WarningTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.8em 0;
  background: #2e2e2e;

  > *:not(:first-child) {
    margin-left: 0.2em;
  }
`;

const WarningContent = styled.div`
  padding: 1.5em 1em;
`;

const WarningText = styled.p`
  line-height: 1.6;
  margin: 0;

  & + & {
    margin-top: 0.75em;
  }
`;

/**
 * Devices section
 */
class Devices extends PureComponent {
  render() {
    const { game, gameId } = this.props;

    return (
      <Container>
        <Heading>DEVICES</Heading>
        <SubHeading>
          <Translate id="landingPage.devices.subtitle" />
        </SubHeading>
        {!game && <Indicator spin />}
        {game && (
          <Content>
            <SupportedDevices gameId={gameId} />
            <WarningTitle>
              <FaExclamationTriangle size="1.25em" />
              <span>
                <Translate id="landingPage.devices.rental.title" />
              </span>
            </WarningTitle>
            <WarningContent>
              <WarningText>
                <Translate id="landingPage.devices.rental.text.1" />
              </WarningText>
              <WarningText>
                <Translate id="landingPage.devices.rental.text.2" />
              </WarningText>
              <WarningText>
                <Translate
                  id="landingPage.devices.rental.text.3"
                  options={{ renderInnerHtml: true }}
                />
              </WarningText>
            </WarningContent>
          </Content>
        )}
      </Container>
    );
  }
}

/**
 * Map Redux State to props
 */
const mapStateToProps = ({ global, firebase }) => {
  const gameId = global.gameId;
  return {
    gameId,
    game: getVal(firebase.data, `games/${gameId}`),
    databaseLoaded: global.loadedResources.database
  };
};

export default compose(
  connect(mapStateToProps, null),
  firebaseConnect(({ gameId, databaseLoaded }) => {
    // Check for database loaded
    if (!databaseLoaded) {
      return;
    }
    return [`games/${gameId}`];
  })
)(Devices);
